import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_not-authed")({
  component: RouteComponent,
});

function RouteComponent()
{
  return <Outlet />;
}
